import React from "react"
import { Row, Col, Panel, Image, Glyphicon } from "react-bootstrap"

class ImageThumbnailSelector extends React.Component {

    render() {

        let sourceImageThumbnails = this.props.sourceFiles.map( sourceFile => 
            <Col xs={6} md={4} key={`Col-${sourceFile.imageMd5}`}>
                <Image src={sourceFile.filePreviewUrl} 
                    thumbnail 
                    alt={sourceFile.file.name} 
                    key={sourceFile.imageMd5}
                    onClick={() => this.props.onSelectImageClicked(sourceFile.imageMd5)}
                    className={sourceFile.imageMd5 === this.props.selectedSourceFileImageMd5ForEdit?"img-thumbnail-selected":""}/>
            </Col>
        )

        return (
            <Panel>
                <Panel.Heading>
                    Select image to work with
                    {this.props.nudgeFromSelectImages ? <Glyphicon glyph="arrow-down" className="nudge-down cmwd-anim-nudge-down"/> : ""}
                </Panel.Heading>
                <Panel.Body>
                    <Row>
                        {sourceImageThumbnails}
                    </Row>
                </Panel.Body>
            </Panel>
        )
    }
}

export default ImageThumbnailSelector


// WEBPACK FOOTER //
// ./src/components/ImageThumbnailSeletor.jsx